




















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";

@Component
export default class FileReaderInput extends Vue {
  @Prop() private label?: string;
  @Prop() private hideHelper?: boolean;
  private password: string = "";
  private focused: boolean = false;
  private inputType: string = "password";
  private passLen: number = 8;

  private hasNumberOrSpecialChar(password: string) {
    let re = /^((?=.*[0-9])|(?=.*[!@#$%^&*()\-_+=,<.>/?'";:[{\]\\|`~}])).*$/;
    return re.test(password);
  }

  private hasLowerCaseChar(password: string) {
    let re = /^(?=.*[a-z]).*$/;
    return re.test(password);
  }

  private hasUpperCaseChar(password: string) {
    let re = /^(?=.*[A-Z]).*$/;
    return re.test(password);
  }

  private validatePassword(password: string) {
    return (
      this.hasLowerCaseChar(password) &&
      this.hasUpperCaseChar(password) &&
      this.hasNumberOrSpecialChar(password) &&
      this.password.length >= this.passLen
    );
  }

  private handleInput(value: string) {
    this.$emit("input", value);
    let valid = this.validatePassword(this.password);
    this.$emit("passwordValid", valid);
  }
}
